import { useMutationObserver, useResizeObserver } from '@vueuse/core';
import { isRef, ref, watch } from 'vue-demi';
import { r as requestAF } from './dom-53c9635b.js';

const useOverflow = (container, options = {}) => {
  const {
    hide = true,
    threshold = 0
  } = options;
  const containerRef = isRef(container) ? container : ref(container);
  // State
  const innerItemsRef = ref([]);
  const outerItemsRef = ref([]);
  // Functions
  function updateState() {
    const container = containerRef.value;
    if (container) {
      const update = [...container.children].reduce(({
        innerItems,
        outerItems
      }, child) => {
        const item = child;
        const {
          x: itemOffset,
          width: itemWidth
        } = item.getBoundingClientRect();
        const {
          x: containerOffset,
          width: containerWidth
        } = container.getBoundingClientRect();
        if (itemOffset + itemWidth > containerOffset + containerWidth + threshold) {
          if (hide) {
            item.style.setProperty('visibility', 'hidden');
          }
          return {
            innerItems,
            outerItems: [...outerItems, item]
          };
        } else {
          if (hide) {
            item.style.removeProperty('visibility');
          }
          return {
            innerItems: [...innerItems, item],
            outerItems
          };
        }
      }, {
        innerItems: [],
        outerItems: []
      });
      innerItemsRef.value = update.innerItems;
      outerItemsRef.value = update.outerItems;
    } else {
      innerItemsRef.value = [];
      outerItemsRef.value = [];
    }
  }
  // Effects
  watch(containerRef, updateState, {
    immediate: true
  });
  useMutationObserver(containerRef, updateState, {
    childList: true
  });
  useResizeObserver(containerRef, () => requestAF(updateState));
  return {
    innerItems: innerItemsRef,
    outerItems: outerItemsRef
  };
};

export { useOverflow as u };
